import React from 'react';
import { PiWarningCircle } from 'react-icons/pi';

// Canonical inline error message — the site had five-plus slightly different
// ad-hoc patterns for this (plain red text, raw Tailwind bg-red-50 instead of
// the site's own error token, inconsistent radius/padding, an icon in some
// spots and not others, role="alert" in almost none of them). That drift is
// what reads as "AI generated" — every form looking like it was styled by a
// different pass. One component, used everywhere, fixes that.
//
// Renders nothing when there's no message, so callers can do
// `<ErrorMessage>{error}</ErrorMessage>` unconditionally instead of
// `{error && <ErrorMessage>...}` — both work, since children is falsy either way.
function ErrorMessage({ children, className = '', ...props }) {
  if (!children) return null;
  return (
    <div
      role="alert"
      className={`uf-error-message flex items-start gap-2 rounded-xl border border-error/30 bg-error/10 px-3.5 py-2.5 text-sm text-error ${className}`}
      {...props}
    >
      <PiWarningCircle className="mt-0.5 h-4 w-4 flex-none" aria-hidden="true" />
      <span className="leading-snug">{children}</span>
    </div>
  );
}

export default ErrorMessage;
